import { useQuery } from "@tanstack/react-query";
import { getAmbassadorProgramStatus } from "@/utils/ambassadorProgramStatus.functions";

/**
 * هل برنامج السفراء مفعَّل؟ أثناء التحميل أو عند الخطأ = false،
 * حتّى لا يظهر البرنامج للعميل وهو متوقّف.
 */
export function useAmbassadorProgramEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ["ambassador-program-status"],
    queryFn: () => getAmbassadorProgramStatus(),
    staleTime: 60_000,
  });
  return data?.enabled === true;
}
